import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const { user } = useSelector(state => state.auth);

  const rolePermissions = {
    'super-admin': [
      'create',
      'read',
      'update',
      'delete',
      'manage-users',
      'settings',
      'bookings',
      'reports',
      'manage-company-status',
      'impersonate',
    ],
    admin: [
      'create',
      'read',
      'update',
      'delete',
      'manage-users',
      'settings',
      'bookings',
      'reports',
    ],
    bookings: [
      'create',
      'read',
      'update',
      'delete',
      'settings',
      'bookings',
      'reports',
    ],
    'view-only': ['artwork'],
  };

  const hasPermission = permission => {
    if (!user?.role) return false;
    return rolePermissions[user.role]?.includes(permission) || false;
  };

  const hasAnyPermission = permissions => {
    return permissions.some(permission => hasPermission(permission));
  };

  const hasAllPermissions = permissions => {
    return permissions.every(permission => hasPermission(permission));
  };

  const canAccessSettings = () => hasPermission('settings');
  const canManageUsers = () => hasPermission('manage-users');
  const canCreateBookings = () => hasPermission('bookings');
  const canViewReports = () => hasPermission('reports');
  const canEdit = () => hasPermission('update');
  const canDelete = () => hasPermission('delete');
  const canCreate = () => hasPermission('create');

  const isSuperAdmin = () => user?.role === 'super-admin';
  const isAdmin = () => user?.role === 'admin';
  const isBookingsUser = () => user?.role === 'bookings';
  const isViewOnly = () => user?.role === 'view-only';

  return {
    user,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    canAccessSettings,
    canManageUsers,
    canCreateBookings,
    canViewReports,
    canEdit,
    canDelete,
    canCreate,
    isSuperAdmin,
    isAdmin,
    isBookingsUser,
    isViewOnly,
    userRole: user?.role,
    roleDisplayName: user?.roleDisplayName,
  };
};
